import { useEffect, useState } from 'react';
import { backendPort } from '../components/Fungsiku';
import axios from 'axios';
import api from "../services/axiosInstance";
import { useNotification } from './NotifPopup';
import {PageKonten17} from './Page17_TransaksiPettyCash';
import {PageKonten20} from './Page20_BulkPettyCash';
import {ExcelDown} from '../components/ExcelDown';
import {sortData} from '../components/Fungsiku';
//import {UploadBulk} from '../components/ExcelBulk';
import {Showing} from '../components/ShowingTabel';

const REQ_GROUP_PAGE14_JURNAL_LOAD = 'page14-jurnal-load';
const REQ_GROUP_PAGE14_SALDO_LOAD = 'page14-saldo-load';

//LPJ PETTY CASH
export function PageKonten14({token, authIdentity = {}, globalOpsi}) {
  const opsiCabang = globalOpsi.opsiCabang;
  const opsiSumber = globalOpsi.opsiSumber;
  const opsiAkun = globalOpsi.opsiAkun;
  const opsiSubAkun = globalOpsi.opsiSubAkun;

  const trimTxt = (txt) =>    (txt ?? "")
                              .toString()
                              .toLowerCase()
                              .replace(/[\r\n]+/g, "")
                              .trim();
  const bulanNow = new Date().getMonth() + 1;
  const tahunNow = new Date().getFullYear();
  const opsiTahun = Array.from({ length: tahunNow - 2025 }, (_, i) => tahunNow - i );

  const [opsiBulan, setOpsiBulan] = useState([]);
  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const namaUser = String(authIdentity?.nama || "").trim();
  const namaCabangUser = (
    kodeCabangUser === "C-1"
      ? "Pusat"
      : (
        (Array.isArray(opsiCabang) ? opsiCabang : []).find(
          (x) => String(x?.kode_cabang || "").trim() === kodeCabangUser
        )?.nama_cabang || kodeCabangUser || "-"
      )
  );
  const sharedAuthProps = { authIdentity };
  const isPusat = kodeCabangUser === "C-1";
  const [cabang, setCabang] = useState(isPusat ? '' : kodeCabangUser);
  const [bulan, setBulan] = useState(''); 
  const [tahun, setTahun] = useState(tahunNow);
  //const bulanLalu = bulan === '' ? 0 : bulan === 1 ? 12 : bulan - 1;  
  //const tahunBlnLalu = bulan === '' ? tahun : bulan === 1 ? tahun -1 : tahun;
  const [saldoAwal, setSaldoAwal] = useState(0);
  //const [tahunLap, setTahunLap] = useState(tahunNow);
  //const [bulanLap, setBulanLap] = useState(bulanNow);
  //const [start, setStart] = useState(formatDATETIMEstart(bulanNow, tahunNow));
  //const [end, setEnd] = useState(formatDATETIMEend(bulanNow, tahunNow));
  
  const [dataProses, setDataProses] = useState(null);
  //const [opsiSumber, setOpsiSumber] = useState([]);
  //const [opsiAkun, setOpsiAkun] = useState([]);
  //const [opsiSubAkun, setOpsiSubAkun] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLPJ, setDataLPJ] = useState([]); 

  const [bljRAB, setBljRAB] = useState(0);
  const [bljMEMO, setBljMEMO] = useState(0);
  const [bljSTORING, setBljSTORING] = useState(0);
  const [totBlj, setTotBlj] = useState(0);
  const [totAlk, setTotAlk] = useState(0);

  const [alkRAB, setAlkRAB] = useState(0);
  const [alkMEMO, setAlkMEMO] = useState(0);
  const [alkSTORING, setAlkSTORING] = useState(0);

  const formatDATETIME = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const mi = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
  };

  const formatDATETIMEstart = (bulan, tahun) => {
      // awal bulan
      const date = new Date(tahun, bulan - 1, 1, 0, 0, 0);
      const hasil = formatDATETIME(date); 
      return hasil;
  };
  const formatDATETIMEend = (bulan, tahun) => {
      // akhir bulan
      const date = new Date(tahun, bulan, 1, 0, 0, 0);
      const hasil = formatDATETIME(date); 
      return hasil;   // 2026-02-01 00:00:00
  };
  
  const formatRibu = (value) => {
    if (value === null || value === undefined) return '0';
    return new Intl.NumberFormat('id-ID').format(Number(value));
  };
  const formatBulan = (value) => {
    return new Intl.DateTimeFormat("id-ID", {month: "long"}).format(new Date(tahun, value-1, 1))
  };
  const { showNotif } = useNotification(); 
  const [open, setOpen] = useState(1);
  const toggle = (id) => {
    setOpen(open === id ? null : id);
  };
  const handleOnChange = () => {
      const startPeriod = formatDATETIMEstart(bulan, tahun);
      const endPeriod = formatDATETIMEend(bulan, tahun);
      loadData(cabang, startPeriod, endPeriod);  
  };
  const loadData = async (cabang, start,end) => {
    if(!bulan){return;};
    
    setLoading(true);
    const t0 = performance.now();
    //ambil saldo awal bulan;
    getSaldo();
    try {
      //ambil jurnal biaya cabang selama 1 bulan.
      api.cancelPendingRequests({
        group: REQ_GROUP_PAGE14_JURNAL_LOAD,
        reason: 'refresh petty jurnal page14',
      });
      const res = await api.get(
        `${backendPort}/api/main/petty_jurnal`,
        {
          params: {
            start,
            end,
            cabang: cabang
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
          requestGroup: REQ_GROUP_PAGE14_JURNAL_LOAD,
          timeout: 30000,
        }
      );
      console.log("Waktu total request:", (performance.now() - t0).toFixed(2), "ms");
      if(res.data.length > 0){
        setDataProses(res.data);
      } else {
        setDataProses(null);
      }
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
    } finally {
      setLoading(false);
    }
  }; 
  
  useEffect(()=>{
    setCabang(cabang);
  },[cabang])
  /** 
  useEffect(() => {
    loadOpsi('sumber');
    loadOpsi('akun');
    loadOpsi('subakun');
    //console.log('Initial : opsiCabang',opsiCabang);
  }, []);
  */
  useEffect(() => {
    setDataLPJ([]);
    handleOnChange();
  }, [bulan]);

  useEffect(()=>{
    const opsiBln = tahun === tahunNow 
    ? Array.from({ length: bulanNow }, (_, i) => bulanNow - i )
    : [12, 11, 10, 9, 8, 7, 6, 5 , 4, 3, 2, 1];
    setOpsiBulan(opsiBln);
    setBulan('');
  },[tahun]);

  const getSaldo = async () => {
    try {
    console.log("get_saldo_awal = kode_cabang:", cabang, "bulan:", bulan, "tahun: ",tahun);
    api.cancelPendingRequests({
      group: REQ_GROUP_PAGE14_SALDO_LOAD,
      reason: 'refresh saldo awal page14',
    });
    const res = await api.get(`${backendPort}/api/main/saldo_awal`, 
      {
        params: { kode_cabang: cabang, bulan: bulan, tahun: tahun }, //menghitung saldo bulan lalu dari bulan ini
        headers: { Authorization: `Bearer ${token}` },
        requestGroup: REQ_GROUP_PAGE14_SALDO_LOAD,
        timeout: 120000,
      });
    setSaldoAwal(Number(res.data.saldo));
    console.log('saldo =', res.data.saldo);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
    }
  };

  useEffect(() => {
    if(!dataProses || dataProses?.length === 0) return;
    console.log('dataProses Change =', dataProses);

    const filtered = sortData(dataProses, 'sumber', 'asc', 'akun', 'asc')
      .filter(item => item.jenis === 'nrm' || item.jenis === 'kor');

    const _rekapAkun = Array.from(
      filtered.reduce((map, item) => {
        const key =
          cabang === 'all'
            ? `${item.sumber}|${item.akun}|${item.subakun}`
            : `${item.kode_cabang}|${item.sumber}|${item.akun}|${item.subakun}`;

        if (!map.has(key)) {
          map.set(key, { ...item });
        } else {
          map.get(key).nominal += item.nominal;
        }
        return map;
      }, new Map()).values()
    );

    setDataLPJ(_rekapAkun);

    function totalSumber(nama, type) {
      const totalBelanja = dataProses
        .filter(row => trimTxt(row.sumber) === trimTxt(nama) && (row.jenis === 'nrm' || row.jenis === 'kor'))
        .reduce((sum, row) => sum + Number(row.nominal), 0);

      const totalAlokasi = dataProses
        .filter(row => trimTxt(row.sumber) === trimTxt(nama) && (row.jenis === 'drp' || row.jenis === 'kdr'))
        .reduce((sum, row) => sum + Number(row.nominal), 0);

      const result = type === 'blj' ? (-1 * totalBelanja) : totalAlokasi;
      return result === 0 ? 0 : result;
    }

    const _bljRAB = totalSumber('RAB' , 'blj');
    const _bljMEMO = totalSumber('MEMO' , 'blj');
    const _bljSTORING = totalSumber('STORING' , 'blj');
    const _alkRAB = totalSumber('RAB' , 'alk');
    const _alkMEMO = totalSumber('MEMO' , 'alk');
    const _alkSTORING = totalSumber('STORING' , 'alk');
    const _totBlj = _bljRAB + _bljMEMO + _bljSTORING;
    const _totAlk = _alkRAB + _alkMEMO + _alkSTORING;

    setBljRAB(_bljRAB);
    setBljMEMO(_bljMEMO);
    setBljSTORING(_bljSTORING);
    setAlkRAB(_alkRAB);
    setAlkMEMO(_alkMEMO);
    setAlkSTORING(_alkSTORING);
    setTotBlj(_totBlj);
    setTotAlk(_totAlk);
  }, [dataProses, cabang]);

  useEffect(() => {
    if (!bulan) return;
    getSaldo();
  }, [bulan, tahun, cabang]);

  const renderLaporanOperasional = () => (
    <div className="accordion-item page14-acc-item">
      <button
        className="accordion-header text-white page14-acc-header"
        onClick={() => bulan === '' ? showNotif('error', 'Belum Pilih Periode') : toggle(3)}
      >
        {`Laporan Biaya Operasional`}
        
      </button>
      <div className={`accordion-body ${open === 3 ? 'open' : ''}`}>
        <div className="accordion-content page14-acc-body">
          <div className="card-body p-0">
            <div className="row my-2 mx-0">
              <div className='card card-body-0 page14-inner-card'>
                <div className='row mt-2 mb-2'>
                  <div className="fs-5 col-md-8 mt-2">Realisasi Biaya Operasional</div>
                  <div className="fs-6 fs-light col-md-8 my-2">
                    {`${opsiCabang?.find(x => x.kode_cabang === cabang)?.nama_cabang ?? ''}, ${formatBulan(bulan)} ${tahun}`}
                  </div>
                  <div className="col-md-4 justify-content-end">
                    <input
                      className="form-control text-end justify-content-end page14-input"
                      value={formatRibu(totBlj)}
                      disabled
                    />
                  </div>
                </div>
                <div className="row justify-content-between align-items-center g-3 my-2">
                  <div className="col-md-8 fs-6 fs-light">
                    <div>DOWNLOAD</div>
                  </div>
                  <div className="row col-md-4 text-end">
                    <div className="col-md-6"></div>
                    <div className="col-md-6">
                      <button
                        type="button"
                        className="btn btn-success page14-btn-success"
                        onClick={() => {ExcelDown('TabelLPJ', `LPJ_${namaCabangUser}_${bulan}_${tahun}`)}}
                      >EXCEL</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Showing dataTabel={dataLPJ} type={'dataLPJ'} opsiCabang={opsiCabang}/>
          </div>
        </div>
      </div>
    </div>
  );
  

//LPJ PETTY CASH
  return (
    <div className="container-fluid" style={{background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"}}>
      <div className="row">
        <div className="text fw-bold">
          <label className="text fw-bold text-end">{`User : ${namaUser} (${namaCabangUser})`}</label>
          <div className="flex-grow h-px bg-gray-300 mb-3"></div>
          </div> 
                {/* KONTEN */}
              <div className="container-fluid">
                
                <div className='row'>
                <div className='col-md-6'>
                  {/* KOLOM 1 */}
                <div className="row">
                {/*PERIODE*/}
                <div className = 'row mb-3 col-md-12'>
                        <div className = 'col-md-4'>
                          <select
                            className="form-control border-danger page14-input"
                            value={cabang}
                            onChange={(e) => setCabang(e.target.value)}>
                               
                            { isPusat 
                              ? <><option value={''}>-Pilih Cabang-</option> <option value={'all'}>-Semua Cabang-</option></> 
                              : null
                              } 
                            {
                              isPusat 
                              ? opsiCabang.map(x => (<option key={x.kode_cabang} value={x.kode_cabang}>{x.nama_cabang}</option>))
                              : <option value={kodeCabangUser}>{namaCabangUser}</option>
                            }
                            </select> 
                        </div>
                        <div className = 'col-md-3'>
                          <select
                            className="form-control border-danger page14-input"
                            value={tahun}
                            onChange={(e) => {
                              setTahun(e.target.value);}}>
                            <option value={tahunNow}>{tahunNow}</option>
                            {opsiTahun.map(x => (x === tahunNow ? null : <option key = {x} value={x}>{x}</option>))}
                          </select>
                        </div>
                        <div className = 'col-md-4'>
                          <select
                            className="form-control border-danger page14-input"
                            value={bulan}
                            onChange={(e) => {
                              isPusat && cabang === '' ? showNotif('error', 'Pilih Cabang Terlebih Dahulu') 
                              : setBulan(e.target.value);
                              }}>

                            <option key={''} value={''}>-Pilih Bulan</option>
                            {opsiBulan.map((x,i) => <option key={`${x}-${i}`} value={x}>{formatBulan(x)}</option>)}
                          </select>
                        </div>
                         
                        <div className='col-md-1 text-end'>
                            <button
                                type = "button"
                                disabled={bulan === ''}
                                className="btn ml-3 btn-primary"
                                onClick={()=>{if(bulan === '') {showNotif('error', 'Belum Pilih Periode')} else {handleOnChange()}}}
                                ><i className="fa fa-arrows-rotate text-white"/>
                            </button>
                        </div>
                </div>
                </div>
                <div className="flex-grow h-px bg-gray-300 mb-3"></div>

                  {/* MINIBOX */}
                <div className='row page14-side-summary'>
                    <div className='fs-5 fw-bold mt-3 d-flex justify-content-between page14-section-title'>
                        <div>REALISASI BIAYA</div>
                      </div>
                      <div className="row g-2 mb-3">
                        <MiniBox title={"RAB"} nominal={-0 ? 0 : bljRAB} />
                        <MiniBox title={"MEMO"} nominal={-0 ? 0 : bljMEMO} />
                        <MiniBox title={"STORING"} nominal={-0 ? 0 : bljSTORING} />
                        <MiniBox title={"TOTAL"} nominal={-0 ? 0 : totBlj} />
                      </div>
                  <div>
                  {/* DASHBOARD */}  
                    <div className = 'row'>
                      <div className='fs-6 mt-3 fw-bold d-flex justify-content-between text-center'>
                        <div>ALOKASI DANA</div>
                      </div>
                      <div className='px-3 fs-6 mt-2 d-flex justify-content-between text-center'>
                        <div>RAB: </div>
                        <div>Rp  {formatRibu(alkRAB)}</div>
                      </div>
                      <div className='px-3 fs-6 mt-2 d-flex justify-content-between text-center'>
                        <div>By Memo: </div>
                        <div>Rp  {formatRibu(alkMEMO)}</div>
                      </div>
                      <div className='px-3 fs-6 mt-2 mb-2 d-flex justify-content-between text-center'>
                        <div>Storing: </div>
                        <div>Rp  {formatRibu(alkSTORING)}</div>
                      </div>
                      <hr/>         
        
                      <div className='fs-6 mt-2 fw-bold d-flex justify-content-between text-center' style={{color: "#2a709b"}}>
                        <div>Saldo Awal Periode: </div>
                        <div>Rp  {formatRibu(saldoAwal)}</div>
                      </div>
                      <div className='fs-6 mt-2 d-flex justify-content-between text-center'>
                        <div>Alokasi Dana: </div>
                        <div>Rp  {formatRibu(totAlk)}</div>
                      </div>
                      <div className='fs-6 mt-2 d-flex justify-content-between text-center'>
                        <div>Pengeluaran: </div>
                        <div>Rp  {formatRibu(totBlj)}</div>
                      </div>
                      <div className='fs-6 mt-2 fw-bold d-flex justify-content-between text-center' style={{color: "#2a709b"}}>
                        <div>Saldo Akhir Periode: </div>
                        <div>Rp  {formatRibu(saldoAwal + totAlk - totBlj)}</div>
                      </div>
                    </div>        
                  </div>
                  
                </div>
                </div>

                        {/* KOLOM 2 */}
                <div className="col-md-6">         
                  {/*ACCORDION*/}
                  <div className="accordion-manual page14-accordion">
                    {/*INPUT TRANSAKSI*/}  
                    <div className="accordion-item page14-acc-item">
                              <button
                              className="accordion-header text-white page14-acc-header"
                              onClick={()=>toggle(1)}
                              >
                    {`Input Transaksi`}
                              
                              </button>
        
                      <div className={`accordion-body ${open === 1 ? 'open' : ''}`}>
                          <div className="accordion-content">
                                    {<PageKonten17 
                                        dataProses={dataProses}
                                        {...sharedAuthProps}
                                        globalOpsi={globalOpsi} 
                                        token={token}
                                        />}
                          </div>
                         </div>
                      </div>
        
                     {/*INPUT BULK TRANSAKSI*/}
                    <div className="accordion-item page14-acc-item">
                        <button
                        className="accordion-header text-white page14-acc-header"
                        onClick={() => toggle(2)}
                        >
                        {`Input Bulk Transaksi`}
                        
                        </button>
        
                        <div className={`accordion-body ${open === 2 ? 'open' : ''}`}>
                        <div className="accordion-content">
                              
                            {/*KONTEN 2*/}
                          <PageKonten20  
                            {...sharedAuthProps}
                            globalOpsi = {globalOpsi} 
                            token={token}/>
                        </div>
                        </div>
                      </div>                  
                    </div>

                    <div className="accordion-manual page14-accordion mt-3">
                      {renderLaporanOperasional()}
                    </div>
                 </div>
        
                </div>
              </div>
      </div>
    </div>
  );
}

function MiniBox({ title, nominal}) {
  const formatRibu = (value) => {
    if (value === null || value === undefined) return '0';
    return new Intl.NumberFormat('id-ID').format(Number(value));
  };
  return (
    <div className="col-6 col-lg-3">
      <div className="text-white py-1 fw-bold text-center page14-minibox-title">{title}</div>
      <div className="py-1 text-center page14-minibox-value">
        <div className="page14-minibox-nominal">{formatRibu(nominal)}</div>
      </div>
    </div>
  );
}
